import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api, { apiError } from "../api";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const black = "#111111";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Link invalid"); return; }
    if (password.length < 6) { toast.error("Parola trebuie sa aiba minim 6 caractere"); return; }
    if (password !== confirm) { toast.error("Parolele nu coincid"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Parola a fost resetata");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(apiError(err, "Resetare esuata"));
    } finally { setLoading(false); }
  };

  const inputCls = "w-full mb-4 px-3 py-2 rounded-md border border-gray-300 outline-none focus:border-gray-500";

  return (
    <div className="min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: "#ffffff", color: black, fontFamily: "Arial, sans-serif", fontSize: "12px" }}>
      <div className="w-full max-w-sm" data-testid="reset-password-page">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-md border border-gray-300 flex items-center justify-center">
            <KeyRound className="w-5 h-5" style={{ color: black }} />
          </div>
          <span style={{ fontSize: "18px" }} className="font-bold">YVOLA</span>
        </div>
        {done ? (
          <div className="text-center" data-testid="reset-password-success">
            <CheckCircle2 className="w-12 h-12 mx-auto mb-4" style={{ color: "#059669" }} />
            <h2 style={{ fontSize: "20px" }} className="font-bold">Parola resetata</h2>
            <p className="mt-2" style={{ fontSize: "13px" }}>Te ducem la autentificare...</p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-password-form">
            <h2 style={{ fontSize: "20px" }} className="font-bold">Seteaza o parola noua</h2>
            <p className="mt-1 mb-8" style={{ fontSize: "13px" }}>Introdu noua parola pentru contul tau.</p>
            <label className="block mb-1" style={{ fontSize: "13px" }}>Parola noua</label>
            <input data-testid="reset-password-input" type="password" required minLength={6}
              value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="parola noua" />
            <label className="block mb-1" style={{ fontSize: "13px" }}>Confirma parola</label>
            <input data-testid="reset-password-confirm-input" type="password" required minLength={6}
              value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} placeholder="confirma parola" />
            <button data-testid="reset-password-submit" type="submit" disabled={loading}
              className="w-full flex items-center justify-center gap-2 py-2.5 rounded-md text-white font-medium disabled:opacity-60"
              style={{ backgroundColor: black, fontSize: "13px" }}>
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Reseteaza parola
            </button>
            <p className="mt-5 text-center" style={{ fontSize: "13px" }}>
              <Link to="/login" className="underline" data-testid="reset-to-login">Mergi la autentificare</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
